/**
 * @deprecated
 * business logic moved to /shared/lib/localStorage namespace
 */
export enum LOCAL_STORAGE {
  EmailSignIn = 'email',
  AuthToken = 'authToken',
  User = 'user',
  CodeCountdownStartedAt = 'codeCountdownStartedAt',
  CodeTriesLeft = 'codeTriesLeft',
  UserInfoStep = 'userInfoStep',
  Code = 'code',
  UserNickname = 'userNickname',
  Tab = 'tab',
  Nickname = 'nickname',
  DiscoveryUsers = 'discoveryUsers',
}

export const getAllLocalStorageItems = () => {
  const storageObj: {[key: string]: string | null} = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      const value = localStorage.getItem(key);
      try {
        storageObj[key] = JSON.parse(value!);
      } catch (_e) {
        storageObj[key] = value;
      }
    }
  }
  return storageObj;
};
